export default __webpack_public_path__ + "static/media/404.7a20d452.gif";